var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "company-list" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-md-12 col-lg-11" }, [
          _c("div", { staticClass: "title-row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "row justify-content-end" }, [
              _c("div", { staticClass: "col-xl-4" }, [
                _c("div", { staticClass: "sort__blck" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.closetoogleshow4,
                          expression: "closetoogleshow4"
                        }
                      ],
                      staticClass: "filter-blck filter-dropdown"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-full btn-white small dropdown",
                          on: {
                            click: function($event) {
                              _vm.show4 = !_vm.show4
                            }
                          }
                        },
                        [_vm._v("Fixed price 1 year")]
                      ),
                      _vm._v(" "),
                      _c("transition", { attrs: { name: "fade" } }, [
                        _vm.show4
                          ? _c("div", { staticClass: "dropdown__el" }, [
                              _c("div", { staticClass: "dropdown-list" }, [
                                _c("div", { staticClass: "dropdown-item" }, [
                                  _vm._v("Fixed price 6 months")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-item" }, [
                                  _vm._v("Fixed price 6 months")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-item" }, [
                                  _vm._v("Fixed price 6 months ")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-item" }, [
                                  _vm._v("Fixed price 6 months")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-item" }, [
                                  _vm._v("Fixed price 6 months")
                                ])
                              ])
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "company-items" }, [
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.CompanyList, function(companyItem) {
                return _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [_c("company-item", { attrs: { companyItem: companyItem } })],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "show-more p-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-blue small",
                      class: { load: _vm.preloaded },
                      attrs: { disabled: _vm.preloaded },
                      on: { click: _vm.preloadBlock }
                    },
                    [
                      _vm._v(
                        "\n                                    Show more (Total: 95)\n                                    "
                      ),
                      _vm.preloaded
                        ? _c("span", [
                            _c("img", {
                              attrs: { src: "/img/tail-spin.svg", alt: "" }
                            })
                          ])
                        : _vm._e()
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xl-12" }, [
        _c("p", { staticClass: "p-title Raleway p-black" }, [
          _c("b", [_vm._v("We compare all power companies")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "Raleway min-med p-dgrey" }, [
          _vm._v("Our goal is to be the best at what we do. "),
          _c("b", [_vm._v("TecknaEl.se")]),
          _vm._v(" compares "),
          _c("b", [_vm._v("143")]),
          _vm._v(
            " Sweden's electricity trading companies. Click on a company for more information."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "Raleway med p-black mb-0" }, [
      _c("b", [_vm._v("Sort by:")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }